
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/layout/hero-section.kpa`,
      template: `<header class="hero-section box-shadow{{setDirection}}" style="height: {{height}}vh;"
        aria-label="Hero Section"
    >
        <div class="background-image" style="background-image: linear-gradient(to top, rgba(44, 65, 67, .6) 30%, rgba(44, 65, 67, .4) 100%), url('{{backgroundImage}}');"></div>
        <div class="wrapper" style="height: {{height}}vh;">
            <div class="hero-card">
                <span if="subheadline" class="subh1 text-shadow" id="hero-subtitle">{{subheadline}}</span>
                <h1 if="headline" id="hero-headline" class="text-shadow">{{headline}}</h1>
                <p if="text" class="text-shadow">{{text}}</p>
                <span>
                    <button if="buttonText" id="btn1" class="btn-cta box-shadow btn1" aria-label="Call to action">{{buttonText}}</button>
                    <button if="buttonText2" id="btn2" class="btn-cta box-shadow btn1" aria-label="Call to action">{{buttonText2}}</button>
                </span>
            </div>
        </div>
    </header>`,
      style: `hero-section .hero-section {
  position: relative;
  min-height: 750px;
  overflow: hidden;
  position: relative;
}
hero-section .hero-section .background-image {
  position: relative;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-blend-mode: multiply; /* multiply color-burn overlay soft-light */
}
hero-section .hero-section .background-image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(44, 65, 67, 0);
  -webkit-backdrop-filter: blur(3px);
          backdrop-filter: blur(3px);
}
hero-section .hero-section .wrapper {
  position: relative;
  top: -100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
  padding: 128px 64px 64px 64px;
}
hero-section .hero-section .wrapper .hero-card {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  transform-origin: left center;
  max-width: 840px;
  padding: 32px 0 32px 32px;
  border-left: 3px solid #62be6a;
}
hero-section .hero-section .wrapper .hero-card .subh1 {
  font-size: 1.2rem;
  margin-bottom: 0;
  color: #eeeeee;
  display: inline-block;
  width: auto;
  padding: 4px 12px;
  border-radius: 32px;
  font-weight: 700;
}
hero-section .hero-section .wrapper .hero-card h1, hero-section .hero-section .wrapper .hero-card p {
  margin: 0;
  padding: 0;
  color: #eeeeee;
}
hero-section .hero-section .wrapper .hero-card h1 {
  font-size: 3rem;
}
hero-section .hero-section .wrapper .hero-card p + span {
  transform-origin: left top;
}
hero-section .hero-section .wrapper .hero-card p {
  font-size: 1.2rem;
  color: #eeeeee;
}
hero-section .hero-section .wrapper .hero-card p strong {
  font-size: 1.9rem;
  color: #62be6a;
}
hero-section .hero-section .wrapper .hero-card span {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;
  width: 100%;
}
hero-section .hero-section .wrapper .hero-card span:empty {
  display: none;
}
hero-section .hero-section .wrapper .hero-card .btn-cta {
  height: 64px;
  font-weight: 700;
  text-transform: uppercase;
  border-radius: 64px;
  font-size: 1rem;
}
hero-section .hero-section .wrapper .hero-card .btn2 {
  background-color: transparent;
  color: #ffffff;
  border: 2px solid #ffffff;
}
hero-section .hero-section .wrapper .hero-card .btn2:hover {
  background-color: #4a9e51;
}
@media (min-width: 1441px) {
  hero-section .hero-section .wrapper .hero-card {
    transform: scale(1.6);
  }
  hero-section .hero-section .wrapper .hero-card p + span {
    transform: scale(0.625);
  }
}
@media (min-width: 1130px) and (max-width: 1440px) {
  hero-section .hero-section .wrapper .hero-card {
    transform: scale(1.3);
  }
  hero-section .hero-section .wrapper .hero-card p + span {
    transform: scale(0.7692307692);
  }
}
@media (max-width: 576px) {
  hero-section .hero-section .wrapper .hero-card h1 {
    font-size: 2.1rem;
    color: #ffffff;
    display: inline-block;
  }
  hero-section .hero-section .wrapper .hero-card p {
    font-size: 1.2rem;
    max-width: 600px;
    color: #eeeeee;
    display: block;
  }
  hero-section .hero-section .wrapper .hero-card p strong {
    font-size: 1.5rem;
  }
}
@media (max-width: 400px) {
  hero-section .hero-section .wrapper .hero-card h1 {
    font-size: 1.7rem;
  }
  hero-section .hero-section .wrapper .hero-card p {
    font-size: 1rem;
  }
  hero-section .hero-section .wrapper .hero-card strong {
    font-size: 1.3rem;
  }
  hero-section .hero-section .wrapper .hero-card .btn1 {
    font-size: 1rem;
  }
}
@media (max-width: 330px) {
  hero-section .hero-section .wrapper .hero-card {
    padding-left: 16px;
  }
}
@media (max-width: 992px) {
  hero-section .hero-section .wrapper {
    padding: 96px 32px 32px 32px;
    top: calc(-100% + 32px);
  }
}
hero-section .hero-section.center .wrapper {
  align-items: center;
}
hero-section .hero-section.center .wrapper .hero-card {
  align-items: center;
  padding: 32px 0;
  border-left: 0;
  border-right: 0;
  transform-origin: center center;
}
hero-section .hero-section.center .wrapper .hero-card p + span {
  transform-origin: center center;
}
hero-section .hero-section.center .wrapper .hero-card h1, hero-section .hero-section.center .wrapper .hero-card p {
  text-align: center;
}
hero-section .hero-section.center .wrapper .hero-card span {
  justify-content: center;
}
hero-section .hero-section.right .wrapper {
  align-items: flex-end;
}
hero-section .hero-section.right .wrapper .hero-card {
  align-items: flex-end;
  padding: 32px 32px 32px 0;
  border-left: 0;
  border-right: 3px solid #62be6a;
  transform-origin: right top;
}
hero-section .hero-section.right .wrapper .hero-card p + span {
  transform-origin: right top;
}
hero-section .hero-section.right .wrapper .hero-card h1, hero-section .hero-section.right .wrapper .hero-card p {
  text-align: right;
}
hero-section .hero-section.right .wrapper .hero-card span {
  justify-content: flex-end;
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    props: {
        backgroundImage: {
            type: 'string',
            required: true,
        },
        headline: {
            type: String,
            default: "",
        },
        subheadline: {
            type: String,
            default: "",
        },
        text: {
            type: String,
            default: "",
        },
        buttonText: {
            type: String,
            default: "",
        },
        buttonLink: {
            type: String,
            default: "",
        },
        buttonText2: {
            type: String,
            default: "",
        },
        buttonLink2: {
            type: String,
            default: "",
        },
        direction: {
            type: String,
            default: "left",
        },
        height: {
            type: String,
            default: "100",
        },
    },
    methods: {
        setDirection() {
            return this.direction ? \` $-{this.direction}\` : " left";
        }
    },
    events: [
        ['click', '.hero-section button#btn1', function (event) {
                event.preventDefault();
                if (this.buttonLink)
                    router.navigate(this.buttonLink);
            }],
        ['click', '.hero-section button#btn2', function (event) {
                event.preventDefault();
                if (this.buttonLink2)
                    router.navigate(this.buttonLink2);
            }],
    ]
};
 })()`
    };
  